import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Customer } from 'src/app/interfaces/customer';
import { Update } from 'src/app/interfaces/update';
import { TruncateModule } from '@yellowspot/ng-truncate';
import { TranslateModule } from '@ngx-translate/core';
import { NgIf } from '@angular/common';
import { TranslateTextDirective } from '../../../../directives/translate-text.directive';
import { CardComponent } from '../../../../components/cards/card/card.component';

@Component({
  selector: 'app-organisation-home',
  templateUrl: './organisation-home.component.html',
  standalone: true,
  imports: [
    CardComponent,
    TranslateTextDirective,
    NgIf,
    TranslateModule,
    TruncateModule,
  ],
})
export class OrganisationHomeComponent {
  @Input() customer: Customer;
  @Input() latestUpdate: Update;
  @Input() language: string;
  @Output() switchTab: EventEmitter<string> = new EventEmitter<string>();

  constructor() {}

  goToTab(event) {
    this.switchTab.next(event);
  }
}
